<template>
  <v-input
    ref="input"
    v-model="localValue"
    type="text"
    class="input--calculator"
    @input="handleInput"
  />
</template>

<script>
export default {
  name: 'VDecimalInput',
  props: {
    value: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
  },
  methods: {
    handleInput(inputValue) {
      if (this.isValidDecimalValue(inputValue)) {
        this.$emit('input', Number(inputValue));
      }
    },
    isValidDecimalValue(value) {
      // Check for decimal, e.g. 12.04
      if (value.toString().match(/^\d+\.\d+$/) !== null) {
        return true;
      }

      // Check for integer, e.g. 12
      if (value.toString().match(/^\d+$/) !== null) {
        return true;
      }

      return false;
    },
  },
};
</script>
